import { ajaxCall } from "@/shared/connection/ajax-call";
import { makeLogger } from "@/shared/consola";

const logger = makeLogger("stats.service");

const STATS_ENDPOINT = `/stats`;

export const statsService = {
    saveLoveStats(wallId, uuid) {
        return saveStats({ wallId, uuid, type: "love" });
    },
    saveLegalStats(footerId, uuid, urlView) {
        return saveStats({ footerId, urlView, uuid, type: "legal" });
    },
    savePlayerStats(playerId, uuid) {
        return saveStats({ playerId, uuid, type: "player" });
    },
    savePricingStats(pricingId, uuid) {
        return saveStats({ pricingId, uuid, type: "pricing" });
    },
    saveFaqStats(faqId, uuid) {
        return saveStats({ faqId, uuid, type: "faq" });
    },
};

async function saveStats({ faqId, footerId, wallId, playerId, pricingId, urlView, uuid, type }) {
    // player can be without iframe:
    if (window.location === window.parent.location && !playerId) {
        // Do not save stats, because we are not inside iFrame, or it is not a player
        logger.debug("parent !== window - do not record...");
        return;
    }
    if (!document.referrer) {
        // Do not take action, referrer not present.
        logger.debug("no referrer, do not record");
        return;
    }
    // Player is not iFrame dependent
    const url = playerId ? window.location.href : document.referrer;
    const location = window.location.href;

    const payload = {
        faqId,
        footerId,
        wallId,
        playerId,
        pricingId,
        url,
        urlView,
        location,
        uuid,
        type,
    };

    logger.debug("saveStats, with payload: ", payload);

    return ajaxCall.post(STATS_ENDPOINT, payload).catch((e) => {
        logger.error(e);
    });
}
